import * as yup from 'yup'

const dnsManagementTypes = ['cname', 'a', 'aaaa', 'mx', 'txt', 'spf'] as const

// Schema for DNS management items when dns_enable is true
const dnsManagementItemSchema = yup.object({
    name: yup.string().required('Tên DNS không được để trống'),
    type: yup
        .mixed<(typeof dnsManagementTypes)[number]>()
        .oneOf(dnsManagementTypes, 'Loại DNS không hợp lệ')
        .required('Loại DNS là bắt buộc'),
    target: yup.string().required('Target không được để trống'),
})

// Schema for DNS management items when dns_enable is false (no validation)
const dnsManagementItemSchemaOptional = yup.object({
    name: yup.string(),
    type: yup.mixed<(typeof dnsManagementTypes)[number]>(),
    target: yup.string(),
})

export const serviceInformationSchema = yup.object({
    notification_name: yup.string().required(),
    dns_enable: yup.boolean().required(),
    dns_managements: yup.array().when('dns_enable', {
        is: true,
        then: () =>
            yup
                .array(dnsManagementItemSchema)
                .min(1, 'Cần ít nhất một mục DNS khi bật DNS'),
        otherwise: () =>
            yup.array(dnsManagementItemSchemaOptional).notRequired(),
    }),
    metadata: yup.array(
        yup.object({
            key: yup.string().required('Key không được để trống'),
            value: yup.string().required('Value không được để trống'),
        })
    ),
    documentations: yup.array(
        yup.object({
            name: yup.string().required('Tên tài liệu không được để trống'),
            link: yup
                .string()
                .url('Link không hợp lệ')
                .required('Link là bắt buộc'),
        })
    ),
})
